import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, observable } from 'rxjs';
import { PlansData, QuestionsData, SimpleAccordionData } from '../common/classes';
import { LocalStorageService } from "./local-storage.service";
import { map } from 'rxjs/operators';
import { find, get } from 'lodash';
import { Router } from '@angular/router';
import { HelpersService } from './helpers.service';

@Injectable({
  providedIn: 'root'
})
export class PlansManagementService {
  public preSelectedPlan: PlansData;

  constructor(
    private localStorage: LocalStorageService,
    private http: HttpClient,
    private router: Router,
    private helpersService: HelpersService
  ) {
  }

  public getMDNList(): Observable<any> {
    return this.http.get<any>(`/ui/api/cxp/mdnlist`)
  }

  public getPlansList(mdn: string): Observable<PlansData[]> {
    return this.http.get<PlansData[]>(`/ui/api/cxp/products/${mdn}`)
  }

  public getFAQ(): Observable<QuestionsData[]> {
    return this.http.get<QuestionsData[]>('/ui/api/cxp/questions')
  }

  public getTnc(spoId: string): Observable<any> {
    return this.http.get<any>('/ui/api/cxp/tnc', {
      params: { spoId }
    }).pipe(
      catchError((error) => {
        this.router.navigate(['/main/tnc-error'])
        return 'Tnc error'
      }),
      map((item) => {
        let targetItem = find(get(item, 'agreementList'), (searchItem) => {
          return searchItem.agreementType === "customerAgreement";
        })
        return targetItem.agreementText;
      }))
  }

  public getNbs(): Observable<any> {
    return this.http.get<any>('/ui/api/cxp/nbs', {
      params: { tnc: 'yes' }
    })
  }

  public subscribe(): Observable<any> {
    return this.http.get<any>('/ui/api/cxp/subscribe');
  }

  public getActivePlan(): Observable<any> {
    return new Observable(subscriber => {
      const dataString: any = this.localStorage.getData('payment-plan');
      console.log('Active plan:', dataString ? JSON.parse(dataString) : null);
      subscriber.next(dataString ? JSON.parse(dataString) : null);
      subscriber.complete()
    })
  }

  public selectPlan(plan: PlansData): Observable<any> {
    return new Observable(subscriber => {
      this.localStorage.saveData('payment-plan', JSON.stringify(plan));
      subscriber.next();
      subscriber.complete()
    })
  }

  public getPlanDropdownsData(): Observable<SimpleAccordionData[]> {
    return new Observable(subscriber => {
      subscriber.next([
        {
          title: 'Unlimited data',
          description: 'Ultra-fast premium data allowance of 15GB per month. After exceeding allowance of 15GB, during times of congestion, data may be temporarily slower than other traffic. Only after exceeding allowance, data reduced to 600 Kbps for the rest of the month.'
        },
        {
          title: 'Multi-Vehicle Connect',
          description: 'Access your data from any 3 qualified vehicles paired with your plan.'
        },
        {
          title: 'Number Share - Vehicle',
          description: 'Talk as much (or as little) as you want in your vehicle, without requiring your phone, when paired with your vehicle.'
        }
      ]);
      subscriber.complete();
    });
  }


  public cancelPlan(): any {

  }

}
